/**
 * File: hideSection.js.
 *
 * Hides Section if no data is found on Loop
 */

 export default {
    insurance: document.querySelector('.udp-insurance-location'),
    services: document.querySelector('.udp-services-location'),
    team: document.querySelector('.udp-team-location'),
	init() {
        if (this.insurance || this.services || this.team ) {
            this.render();
        }
	},
	render() {

        if (this.insurance && this.insurance.querySelector('.elementor-posts-nothing-found') !== null) {
            this.insurance.classList.add('hide-section');
        }
        if (this.services && this.services.querySelector('.elementor-posts-nothing-found') !== null) {
            this.services.classList.add('hide-section');
        }
        if (this.team && this.team.querySelector('.elementor-posts-nothing-found') !== null) {
            this.team.classList.add('hide-section');
        }
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
  